import React from "react";

const HighlightedTitle = ({ text }) => {
  return (
    <div className="hover-colorful-title">
      {text.split("").map((char, index) => (
        <span
          key={index}
          style={{
            "--i": index,
            "--total": text.length,
          }}
        >
          {char}
        </span>
      ))}
      <style jsx>{`
        :root {
          --color1: #ff6f61; /* Customize the colors */
          --color2: rgb(5, 5, 245);
          --color3: rgb(181, 169, 102);
          --color4: rgb(58, 49, 62);
        }

        .hover-colorful-title {
          font-size: 14px;
          cursor: pointer;
        }

        .hover-colorful-title span {
          color: black; /* Default color */
          transition: color 0.3s ease;
          animation: none;
        }

        .project-item:hover .hover-colorful-title span {
          animation: colorCycle 2s linear infinite;
          animation-delay: calc(var(--i) * 0.1s); /* Stagger effect */
        }

        @keyframes colorCycle {
          0% {
            color: var(--color1);
          }
          25% {
            color: var(--color2);
          }
          50% {
            color: var(--color3);
          }
          75% {
            color: var(--color4);
          }
          100% {
            color: var(--color1);
          }
        }
      `}</style>
    </div>
  );
};

export default HighlightedTitle;
